module.exports = __webpack_public_path__ + "media/images/top/introduction/img_hero-7f586391c226c82dfac8e9c05cfcf8e3.png";